import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Popup,
  Heading,
  Button,
  Picture,
  Status,
  Preloader,
  Icon,
} from 'components';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { pathOr } from 'ramda';
import DragNDropContainer from './components/DragNDropContainer';
import { closeValidationPDPopup, sendValidationPDFile } from '../../actions';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const formStates = {
  initial: 'initial',
  overed: 'overed',
  choosed: 'choosed',
  wrongFile: 'wrongFile',
  loading: 'loading',
  failed: 'failed',
  success: 'success',
};

const allowedMimeTypes = [
  'image/jpeg',
  'image/pjpeg',
  'image/png',
];
const acceptedExtensions = '.jpg,.jpeg,.png';

const fileMaxSize = (1024 * 1024) * 10;

const isAllowedFile = (file) => allowedMimeTypes.includes(file.type) && file.size <= fileMaxSize;

const ValidationPDPopup = (props) => {
  const {
    actions,
    isOpen,
    texts,
    uploadPassportUrl,
    isSuccessSended,
    isFailSend,
  } = props;
  const [formState, setFormState] = useState(formStates.initial);
  const [choosedFile, setChoosedFile] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isSuccessSended) {
      setFormState(formStates.success);
    } else if (isFailSend) {
      setFormState(formStates.failed);
    }
  }, [isSuccessSended, isFailSend]);

  const onDragOver = () => {
    if (formState !== formStates.overed) setFormState(formStates.overed);
  };
  const onDragLeave = () => {
    setFormState(formStates.initial);
  };
  const onDrop = (e) => {
    const { files } = e.dataTransfer;
    const file = files && files[0];

    if (file && isAllowedFile(file)) {
      setFormState(formStates.choosed);
      setChoosedFile(file);
    } else {
      setFormState(formStates.wrongFile);
    }
  };

  const onChooseFileBtnClick = () => {
    fileInputRef.current.click();
  };
  const onFileChange = () => {
    const { files } = fileInputRef.current;
    const file = files && files[0];

    if (file && isAllowedFile(file)) {
      setFormState(formStates.choosed);
      setChoosedFile(file);
    } else {
      setFormState(formStates.wrongFile);
    }
  };
  const onSendBtnClick = () => {
    setFormState(formStates.loading);

    actions.sendValidationPDFile(choosedFile, uploadPassportUrl);
  };

  if (!isOpen) return null;

  return (
    <Popup
      onClose={actions.closeValidationPDPopup}
      className={cx('popup')}
      opened
    >
      {formState === formStates.success && (
        <div className={cx('successWrapper')}>
          <Icon className={cx('successIcon')} name="check-circle" />
          <Heading level={3} className={cx('successTitle')}>
            <span dangerouslySetInnerHTML={{ __html: texts.formSuccessSendText }} />
          </Heading>
        </div>
      )}
      {formState === formStates.loading && (
        <div className={cx('preloaderWrap')}>
          <Preloader
            className={cx('preloader')}
            size="80"
          />
        </div>
      )}
      {(
        formState !== formStates.success
        && formState !== formStates.loading
      ) && (
        <div>
          <Heading className={cx('title')} level={1} isStyled={false}>
            <span dangerouslySetInnerHTML={{ __html: texts.popupTitle }} />
          </Heading>

          {formState === formStates.failed && (
            <Status className={['error', cx('statusFail')]} emoji="statusFail">
              <span dangerouslySetInnerHTML={{ __html: texts.sendFail }} />
            </Status>
          )}
          <DragNDropContainer
            className={cx('dragNDrop', {
              overed: formState === formStates.overed,
            })}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
          >
            <>
              {formState === formStates.wrongFile && (
              <Status className={['error', cx('statusFailUpload')]} emoji="statusFail">
                <span dangerouslySetInnerHTML={{ __html: texts.wrongFileText }} />
              </Status>
              )}
              {formState === formStates.choosed && (
              <Status className={['success', cx('statusSuccess')]}>
                <span dangerouslySetInnerHTML={{ __html: texts.successPhotoUpload }} />
              </Status>
              )}
              <div className={cx('passportIconWrap')}>
                <Picture defaultImage={texts.passportIcon} />
              </div>
              <div className={cx('filesText')} dangerouslySetInnerHTML={{ __html: texts.filesText }} />
              <Button
                className={['big', cx('uploadFileBtn')]}
                onClick={onChooseFileBtnClick}
                color={formState === formStates.choosed ? 'light' : undefined}
              >
                {(
                  formState === formStates.choosed
                  || formState === formStates.wrongFile
                ) ? texts.uploadOtherPhotoBtn : texts.uploadPhotoBtn}
              </Button>
              <input
                ref={fileInputRef}
                type="file"
                accept={`${acceptedExtensions},${acceptedExtensions.toUpperCase()}`}
                onChange={onFileChange}
                hidden
              />
            </>
          </DragNDropContainer>
          <div className={cx('orderWrap')}>
            <div className={cx('sendBtnWrap')}>
              <Button
                className="big"
                onClick={onSendBtnClick}
                disabled={formState !== formStates.choosed}
                wide
              >
                <span dangerouslySetInnerHTML={{ __html: texts.sendBtnText }} />
              </Button>

            </div>
            <div className={cx('legal')} dangerouslySetInnerHTML={{ __html: texts.legal }} />
          </div>

        </div>
      )}
    </Popup>
  );
};

ValidationPDPopup.propTypes = {
  actions: PropTypes.shape({
    closeValidationPDPopup: PropTypes.func,
    sendValidationPDFile: PropTypes.func,
  }),

  isOpen: PropTypes.bool,
  isSuccessSended: PropTypes.bool,
  isFailSend: PropTypes.bool,

  texts: PropTypes.shape({
    formSuccessSendText: PropTypes.string,
    popupTitle: PropTypes.string,
    sendFail: PropTypes.string,
    wrongFileText: PropTypes.string,
    successPhotoUpload: PropTypes.string,
    passportIcon: PropTypes.string,
    filesText: PropTypes.string,
    uploadOtherPhotoBtn: PropTypes.string,
    uploadPhotoBtn: PropTypes.string,
    sendBtnText: PropTypes.string,
    legal: PropTypes.string,
  }),

  uploadPassportUrl: PropTypes.string,
};

const mapStateToProps = (state) => {
  const home = pathOr({}, ['home'], state);
  const passportVD = pathOr({}, ['convergence', 'data', 'passportVD'], home);

  return {
    isOpen: state.home.isValidationPDPopupOpen,
    isSuccessSended: home.validationPDRequestStatus === 'success',
    isFailSend: home.validationPDRequestStatus === 'fail',
    texts: passportVD.texts,
    uploadPassportUrl: passportVD.uploadPassportUrl,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    closeValidationPDPopup,
    sendValidationPDFile,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidationPDPopup);
